import React from "react";

const ArcReactorIcon = () => {
	return (
		<svg viewBox="0 0 512 512">
			<g>
				<ellipse
					cx="255.958"
					cy="255.758"
					fill="none"
					rx="237.286"
					ry="227.534"
					stroke="currentColor"
					strokeWidth="32.3899"
				/>
				<g>
					<rect
						height="56.694"
						transform="matrix(-0.3491 0.9371 -0.9371 -0.3491 538.83 -175.0903)"
						width="115.117"
						x="272.664"
						y="71.24"
					/>
					<rect
						height="56.694"
						transform="matrix(0.3491 0.9371 -0.9371 0.3491 215.2442 -110.7131)"
						width="115.117"
						x="129.76"
						y="71.24"
					/>
					<polygon
						fill="none"
						points="    72.96,142.165 443.359,142.165 259.238,464.376   "
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="25.6236"
					/>
					<polygon
						points="163.079,193.23    353.238,193.23 258.715,358.652   "
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="12.4647"
					/>
					<polygon
						fill="none"
						points="    195.707,213.368 196.666,213.384 225.915,213.847 225.915,223.438 292.562,223.438 292.083,213.368 321.33,214.328    306.467,241.179 298.314,234.466 267.15,292.963 274.344,298.235 259.477,321.731 243.655,297.277 251.328,292.481    219.682,234.945 212.008,240.218   "
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="9.2628"
					/>
					<rect
						height="56.694"
						transform="matrix(-0.9775 0.2107 -0.2107 -0.9775 224.6217 517.8996)"
						width="115.117"
						x="27.157"
						y="242.572"
					/>
					<rect
						height="56.695"
						transform="matrix(-0.6706 0.7418 -0.7418 -0.6706 553.1541 542.3175)"
						width="115.118"
						x="98.608"
						y="365.627"
					/>
					<rect
						height="56.694"
						transform="matrix(0.9775 0.2107 -0.2107 0.9775 66.9465 -86.378)"
						width="115.118"
						x="381.193"
						y="242.572"
					/>
					<rect
						height="56.695"
						transform="matrix(0.6706 0.7418 -0.7418 0.6706 413.2617 -142.6938)"
						width="115.117"
						x="309.742"
						y="365.627"
					/>
					<g>
						<rect height="87.334" width="8.824" x="254.414" y="360.859" />
						<path d="M267.649,414.23c0,4.629-3.753,8.381-8.381,8.381l0,0c-4.63,0-8.381-3.752-8.381-8.381v-14.112     c0-4.63,3.751-8.382,8.381-8.382l0,0c4.628,0,8.381,3.752,8.381,8.382V414.23z" />
					</g>
					<g>
						<rect
							height="87.335"
							transform="matrix(0.4711 0.8821 -0.8821 0.4711 358.7657 -250.5172)"
							width="8.821"
							x="383.861"
							y="130.224"
						/>
						<path d="M400.987,177.105c4.083-2.181,5.625-7.259,3.443-11.34l0,0c-2.18-4.084-7.258-5.627-11.339-3.446l-12.451,6.647     c-4.083,2.18-5.624,7.258-3.445,11.341l0,0c2.182,4.083,7.259,5.625,11.341,3.445L400.987,177.105z" />
					</g>
					<g>
						<rect
							height="87.335"
							transform="matrix(-0.471 0.8821 -0.8821 -0.471 340.4345 143.6333)"
							width="8.821"
							x="122.74"
							y="130.224"
						/>
						<path d="M114.435,177.105c-4.082-2.181-5.625-7.259-3.445-11.34l0,0c2.18-4.084,7.257-5.627,11.34-3.446l12.45,6.647     c4.083,2.18,5.626,7.258,3.447,11.341l0,0c-2.182,4.083-7.259,5.625-11.342,3.445L114.435,177.105z" />
					</g>
				</g>
			</g>
		</svg>
	);
};

export default ArcReactorIcon;
